const ru = {
  common: {
    save: 'Сохранить', saveChanges: 'Сохранить изменения', cancel: 'Отмена', delete: 'Удалить',
    edit: 'Изменить', add: 'Добавить', remove: 'Удалить', close: 'Закрыть', back: 'Назад',
    retry: 'Повторить', loading: 'Загрузка…', search: 'Поиск', all: 'Все',
    status: 'Статус', actions: 'Действия', name: 'Имя', email: 'Эл. почта', phone: 'Телефон',
    role: 'Роль', date: 'Дата', joined: 'Регистрация', active: 'Активен', inactive: 'Неактивен',
    banned: 'Заблокирован', yes: 'Да', no: 'Нет', showing: 'Показано', of: 'из',
    somethingWrong: 'Что-то пошло не так', noResults: 'Ничего не найдено', clear: 'Очистить',
    unknown: 'Неизвестно',
  },
  nav: {
    main: 'Основное', admin: 'Администрирование',
    home: 'Главная', courses: 'Курсы', students: 'Студенты', clients: 'Клиенты', sales: 'Продажи',
    leads: 'Лиды', reminders: 'Напоминания', promocodes: 'Промокоды', inbox: 'Входящие', analytics: 'Аналитика',
    calendar: 'Календарь', team: 'Команда', teams: 'Команды', settings: 'Настройки', logout: 'Выйти',
    account: 'Аккаунт', workspace: 'Рабочая область', operations: 'Операции', insights: 'Аналитика', collapse: 'Свернуть меню', expand: 'Развернуть меню', openMenu: 'Открыть навигацию', aiProposals: 'Курсов с AI-предложениями на проверку: {count}',
  },
  topbar: {
    language: 'Язык', notifications: 'Уведомления', profile: 'Профиль',
    signOut: 'Выйти', theme: 'Тема', newCourse: 'Новый курс', noNotifications: 'Нет уведомлений',
    eyebrow: {
      workspace: 'Рабочее пространство', courses: 'Курсы', catalog: 'Каталог', people: 'Люди',
      commerce: 'Коммерция', communication: 'Общение', insights: 'Аналитика',
      planning: 'Планирование', account: 'Аккаунт',
    },
    title: {
      home: 'Главная', createCourse: 'Создать курс', courseWorkspace: 'Управление курсом',
      courses: 'Курсы', students: 'Студенты', clients: 'Клиенты', sales: 'Продажи', inbox: 'Входящие',
      analytics: 'Аналитика', calendar: 'Календарь', team: 'Команда', settings: 'Настройки',
      studentDetail: 'Карточка студента', profile: 'Профиль', quizFeedback: 'Разбор теста', clientDetail: 'Клиент', mentors: 'Менторы',
    },
  },
  students: {
    title: 'Студенты', subtitle: 'Список записей и прогресс по курсу',
    selectCourse: 'Выберите курс…', searchPlaceholder: 'Поиск по имени, почте или телефону',
    pickTitle: 'Выберите курс, чтобы начать',
    pickDesc: 'Выберите один из своих курсов выше, чтобы увидеть записавшихся студентов, их прогресс и статус.',
    emptyTitle: 'Пока нет записавшихся студентов',
    emptyDesc: 'Как только студенты запишутся на этот курс, они появятся здесь.',
    totalEnrolled: 'Всего записано', avgProgress: 'Средний прогресс', completed: 'Завершили', inProgress: 'В процессе',
    filterAll: 'Все', filterInProgress: 'В процессе', filterCompleted: 'Завершено', filterNotStarted: 'Не начато', filterInactive: 'Нет доступа',
    statusCompleted: 'Завершено', statusInProgress: 'В процессе', statusNotStarted: 'Не начато', statusInactive: 'Нет доступа',
    colStudent: 'Студент', colProgress: 'Прогресс', colStatus: 'Статус', colEnrolled: 'Записан', colCompleted: 'Завершил',
    noMatch: 'Нет студентов по этому фильтру.', showingStudents: 'студентов',
    rosterCapped: 'Загружены только первые {loaded} из {total} студентов; счётчики и поиск учитывают только их.',
    colGroups: 'Группы', addToGroup: 'Добавить', assignHead: 'Добавить в группу', inAllGroups: 'Уже во всех группах', allGroups: 'Все группы',
    rosterEyebrow: 'Список студентов', rosterCount: 'Записано студентов: {count}',
    addedToGroup: 'Добавлен в {group}', addGroupFailed: 'Не удалось добавить в группу',
    noGroupsYet: 'Групп пока нет — создайте на странице «Команды».',
    view: 'Открыть', viewDetail: 'Детали студента', detailClose: 'Закрыть', detailLoadFail: 'Не удалось загрузить данные студента',
    backToRoster: 'К списку студентов', detailStudent: 'Студент', detailCompletedOn: 'Завершено {date}',
    detailOverall: 'Общий прогресс', detailLessons: 'Уроков пройдено', detailAvgQuiz: 'Средний балл теста', detailEnrolled: 'Записан',
    detailLessonsSection: 'Прогресс по урокам', detailQuizzes: 'Попытки тестов', detailActivity: 'Недавняя активность',
    detailNoLessons: 'Пока нет активности по урокам.', detailCorrect: '{correct}/{total} верно',
    lessonN: 'Урок {n}', quizN: 'Тест {n}',
    loading: 'Загрузка студентов…', tabAllStudents: 'Все студенты', tabAtRisk: 'В зоне риска',
  },
  orders: {
    title: 'Заказы', subtitle: 'Платежи и история заказов по вашим курсам',
    searchPlaceholder: 'Поиск по клиенту или курсу',
    emptyTitle: 'Пока нет заказов', emptyDesc: 'Когда студенты купят ваши курсы, заказы появятся здесь.',
    totalRevenue: 'Общая выручка', ordersCount: 'Заказы', completed: 'Завершено', avgOrder: 'Средний чек',
    colCustomer: 'Клиент', colCourse: 'Курс', colAmount: 'Сумма', colStatus: 'Статус', colDate: 'Дата',
    noMatch: 'Нет заказов по этому фильтру.', showingOrders: 'заказов', loading: 'Загрузка заказов…',
  },
  discounts: {
    title: 'Скидки',
  },
  feedback: {
    title: 'Отзывы', subtitle: 'Отзывы и оценки курсов от ваших студентов',
    emptyTitle: 'Пока нет отзывов', emptyDesc: 'Когда студенты оставят отзывы о ваших курсах, они появятся здесь.',
    all: 'Все', outOf5: '{value} из 5',
  },
  team: {
    eyebrow: 'Организация', hubSubtitle: 'Управляйте аккаунтами сотрудников и распределяйте их по командам колл-центра, продаж и контроля.', tabPeople: 'Сотрудники', tabTeams: 'Команды',
    title: 'Команда', memberCount: '{count} участников в вашем аккаунте', memberCountOne: '1 участник в вашем аккаунте',
    addMember: 'Добавить', addTeamMember: 'Добавить участника', editMember: 'Изменить участника',
    total: 'Всего', admins: 'Админы', teachers: 'Преподаватели', students: 'Студенты',
    searchPlaceholder: 'Поиск по имени или почте…',
    roleAll: 'Все', roleAdmin: 'Админ', roleTeacher: 'Преподаватель', roleStudent: 'Студент',
    sortNewest: 'Сначала новые', sortOldest: 'Сначала старые', sortNameAsc: 'Имя А–Я', sortNameDesc: 'Имя Я–А',
    colMember: 'Участник', colContact: 'Контакты', colRole: 'Роль', colStatus: 'Статус', colJoined: 'Регистрация', colActions: 'Действия',
    fullName: 'Полное имя', password: 'Пароль', newPassword: 'Новый пароль',
    passwordHint: 'Оставьте пустым, чтобы сохранить текущий пароль', statusActive: 'Активен', statusInactive: 'Неактивен',
    ban: 'Заблокировать', unban: 'Разблокировать', emptyTitle: 'Участники не найдены', emptyDesc: 'Измените фильтры или добавьте нового участника',
    removeTitle: 'Удалить участника?', removeMsg: '«{name}» будет навсегда удалён из вашего аккаунта.',
    banTitle: 'Заблокировать участника?', banMsg: '«{name}» будет заблокирован и потеряет доступ к аккаунту.',
    unbanTitle: 'Разблокировать участника?', unbanMsg: '«{name}» снова получит доступ к аккаунту.',
    sort: 'Сортировка', changeRole: 'Изменить роль', viewGrid: 'Плитка', viewTable: 'Таблица',
    namePlaceholder: 'Иван Иванов', emailPlaceholder: 'user@example.com', phonePlaceholder: '+998901234567',
    passwordPlaceholder: 'Минимум 6 символов', saving: 'Сохранение…',
    nameRequired: 'Введите имя', passwordRequired: 'Пароль обязателен для новых участников',
    failedToSave: 'Не удалось сохранить', failedToLoad: 'Не удалось загрузить команду',
    failedToUpdateRole: 'Не удалось изменить роль', failedToDelete: 'Не удалось удалить участника',
    failedToUpdateBan: 'Не удалось изменить статус блокировки',
    roleChanged: '«{name}»: роль изменена на {role}', removedToast: '«{name}» удалён',
    bannedToast: '«{name}» заблокирован', unbannedToast: '«{name}» разблокирован',
    memberUpdated: 'Участник обновлён', memberAdded: 'Участник добавлен',
    showingRange: 'Показано {from}–{to} из {total}',
  },
  settings: {
    title: 'Настройки', subtitle: 'Управление профилем, аккаунтом и настройками',
    navProfile: 'Профиль', navAccount: 'Аккаунт', navPassword: 'Пароль', navSession: 'Сессия',
    profileTitle: 'Профиль', profileDesc: 'Эта информация видна студентам и участникам команды.',
    yourName: 'Ваше имя', fullName: 'Полное имя', fullNamePlaceholder: 'Ваше полное имя',
    subjectArea: 'Предмет', selectSubject: 'Выберите предмет',
    bio: 'О себе', bioPlaceholder: 'Расскажите студентам о себе, опыте и стиле преподавания',
    uploadPhoto: 'Загрузить фото', avatarAlt: 'Аватар',
    accountTitle: 'Аккаунт', accountDesc: 'Ваши учётные данные и данные аккаунта.',
    accountId: 'ID аккаунта',
    passwordTitle: 'Смена пароля', passwordDesc: 'Используйте надёжный пароль, который не используете где-либо ещё.',
    currentPassword: 'Текущий пароль', newPassword: 'Новый пароль', confirmPassword: 'Подтвердите новый пароль',
    currentPasswordPlaceholder: 'Введите текущий пароль', newPasswordPlaceholder: 'Минимум 6 символов',
    confirmPasswordPlaceholder: 'Повторите новый пароль',
    updatePassword: 'Обновить пароль',
    pwMinLength: 'Пароль должен содержать не менее 6 символов', pwMismatch: 'Пароли не совпадают',
    pwNotAvailable: 'Смена пароля пока недоступна',
    sessionTitle: 'Сессия', signOut: 'Выйти', signOutDesc: 'Завершить текущую сессию на этом устройстве.',
    signOutQ: 'Выйти?', signOutConfirm: 'Вам потребуется войти снова. Несохранённые изменения будут потеряны.',
    saved: 'Профиль сохранён', saving: 'Сохранение…',
    nameRequired: 'Укажите имя', loadFailed: 'Не удалось загрузить профиль', saveFailed: 'Не удалось сохранить',
    loadingSettings: 'Загрузка настроек…',
    subjects: {
      mathematics: 'Математика', english: 'Английский язык', science: 'Естествознание', history: 'История',
      languages: 'Языки', technology: 'Технологии', arts: 'Искусство', other: 'Другое',
    },
  },
  calendar: {
    today: 'Сегодня', month: 'Месяц', week: 'Неделя', newEvent: 'Новое событие',
    categories: 'Категории', allEvents: 'Все события', addCategory: 'Добавить категорию',
    pinned: 'Закреплено', loading: 'Загрузка календаря…',
    newEventTitle: 'Новое событие', editEventTitle: 'Изменить событие', newCategory: 'Новая категория', editCategory: 'Изменить категорию',
    fName: 'Название', fTitle: 'Заголовок', fDate: 'Дата', fTime: 'Время', fDescription: 'Описание', fCategory: 'Категория',
    fColor: 'Цвет', fIcon: 'Иконка', noCategory: '— Без категории —', pinEvent: 'Закрепить событие вверху',
    create: 'Создать', update: 'Обновить',
    placeholderCategoryName: 'например, Математика', placeholderEventTitle: 'Название события',
    placeholderEventTime: '10:00 - 12:00', placeholderDescription: 'Необязательные заметки…',
    saving: 'Сохранение…', moreEvents: '+{count} ещё', previous: 'Назад', next: 'Вперёд',
    failedToLoad: 'Не удалось загрузить данные календаря', failedToSaveEvent: 'Не удалось сохранить событие',
    failedToDeleteEvent: 'Не удалось удалить событие', failedToSaveCategory: 'Не удалось сохранить категорию',
    failedToDeleteCategory: 'Не удалось удалить категорию',
    confirmDeleteEvent: 'Удалить это событие?',
    confirmDeleteCategory: 'Удалить эту категорию? События останутся без категории.',
  },
};

export default ru;
